// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"260bb6ea","513":"a72e5335","703":"9a244083","787":"8a981587"}[chunkId] + ".chunk.js";
};